module.exports = __webpack_public_path__ + "img/bgm-login.bf12ccb0.jpeg";